<template>
  <router-view />
</template>

<script>

export default {
  name: 'AuthenticateToken',
  async created() {
    const query = { ...this.$route.query };
    delete query.phoneNumber;
    this.$router.replace({ query });
  },
  methods: {
  },
};
</script>
